import { useTranslation } from 'react-i18next';

import { Button } from '../buttons/Button';
import { GoogleFontIcon } from '../icons/GoogleFontIcon';

import { LoginFrame } from './LoginFrame';

import styles from './resetPasswordConfirmationWidget.module.scss';

type ResetPasswordConfirmationWidgetProps = {
  onBackToLogin: () => void;
};
export function ResetPasswordConfirmationWidget({
  onBackToLogin,
}: ResetPasswordConfirmationWidgetProps) {
  const { t } = useTranslation();
  return (
    <LoginFrame title={t('app.resetConfirmationWidget.title')}>
      <div className={styles['root']}>
        <div>{t('app.resetConfirmationWidget.confirmation')}</div>
        <Button
          onClick={onBackToLogin}
          variant="text"
          icon={<GoogleFontIcon name="arrow_back_ios_new" small />}
        >
          {t('app.resetConfirmationWidget.back')}
        </Button>
      </div>
    </LoginFrame>
  );
}
